import React from 'react';
import Leads from '../components/Leads';

function LeadsPage() {
  return (
    <Leads/>
  );
}

export default LeadsPage;